import type React from 'react'

import { TextBoxMaxLine1FontXlBold } from 'atoms/TextBox/Templates'
import {
  SettingsMenuContainerSC,
  SettingsMenuSC,
  SettingsMenuWithDividersSC,
} from './SettingsMenu.styled'

interface ISettingsMenuProps {
  isWithDivider?: 0 | 1
  children: React.ReactNode
  title?: string
}

export const SettingsMenu = ({
  isWithDivider = 1,
  children,
  title,
}: ISettingsMenuProps) => {
  const Container = isWithDivider ? SettingsMenuWithDividersSC : SettingsMenuSC

  return (
    <SettingsMenuContainerSC>
      {title && <TextBoxMaxLine1FontXlBold title={title} />}

      <Container>{children}</Container>
    </SettingsMenuContainerSC>
  )
}
